import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { Collection, Tabs } from '@components/common';
import { BorrowingCalendar } from '@components/BorrowingCalendar';

export const ResourceTransactions = ({
    resource,
    onSelectEvent,
    onSelectSlot,
    className = ''
}) => {
    const { t } = useLanguage();

    const renderBorrowingHistoryCalendar = () => {
        return (
            <div className="borrowing-history-calendar-section">
                <BorrowingCalendar
                    contextModel={resource}
                    onSelectEvent={onSelectEvent}
                    onSelectSlot={onSelectSlot}
                    fieldTitle='user'
                    selectable={false}
                    height="1400px"
                    className="resource-borrowing-history-calendar"
                />
            </div>
        );
    };


    // Create tabs configuration
    const tabs = [
        !resource.consumable ? {
            id: 'overview',
            label: t('resourceView.transactions.overview'),
            content: (
                <div className="tab-content overview-tab">
                    {renderBorrowingHistoryCalendar()}
                </div>
            )
        } : null,
        !resource.consumable ? {
            id: 'borrowings',
            label: t('resourceView.transactions.borrowingsAndReservations'),
            content: (
                <div className="tab-content borrowings-tab">
                    <Collection
                        modelName="resources"
                        endpoint="getBorrowings"
                        title={t('resourceView.transactions.borrowingsAndReservations')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={resource.id}
                        className="transaction-collection borrowings-reservations-collection"
                    />
                </div>
            )
        } : null,
        // Only show consumptions tab if resource is consumable
        resource.consumable ? {
            id: 'consumptions',
            label: t('resourceView.transactions.consumptions'),
            content: (
                <div className="tab-content consumptions-tab">
                    <Collection
                        modelName="resources"
                        endpoint="getConsumptions"
                        title={t('resourceView.transactions.consumptions')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={resource.id}
                        className="transaction-collection"
                    />
                </div>
            )
        } : null,
        // Only show refills tab if resource is consumable
        resource.consumable ? {
            id: 'refills',
            label: t('resourceView.transactions.refills'),
            content: (
                <div className="tab-content refills-tab">
                    <Collection
                        modelName="resources"
                        endpoint="getRefills"
                        title={t('resourceView.transactions.refills')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={resource.id}
                        className="transaction-collection"
                    />
                </div>
            )
        } : null
    ];

    return (
        <div className={`resource-transactions ${className}`}>
            <Tabs
                tabs={tabs}
                variant="underline"
                size="medium"
                persistInUrl={true}
                urlParamName="transactionTab"
                className="resource-transactions-tabs"
            />
        </div>
    );
};

export default ResourceTransactions;
